import GameiomIdle from "gameiom/states/gameiom-idle";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import Layers from "slotworks/graphics/layers/layers";
// import bonusSymbolSetup from "utils/bonus-symbol-setup";

export default class CGIdle extends GameiomIdle {

    // public onEnter() {
    //      bonusSymbolSetup.drawAllBonusSymbols();
    // }

    public onExit() {
        lightningBorderAnimationUtil.stop();
        super.onExit();
    }
}
